import { h, t, T, domWithScope } from '@jsx6/jsx6'
/**
 * 
 * @param {Element} logo 
 * @param {ChatBox} chat 
 * @returns Element
 */
export const areaSurvey = (chat) => {
  return (
    <div p="area.survey" class="chatForm" hidden>
      <div class="chatHeading">
        <div class="heading-content" selector="--heading-color">{T`survey`}</div>
        <div class="chatTopbar">
          <span p="bt.minimize" onclick={e => chat.hideSurvey()} icon="x-mark" />
        </div>
      </div>

      <div p="surveyPart.intro1" class="survey-heading"></div>

      <div p="surveyQuestions"></div>

      <div class="form-line buttons-line">
        <button p="bt.sendSurvey" class="btn btn-primary" disabled onclick={e => chat.sendSurvey(false)} selector="--button-bg,--button-txt">
          {T`send`}
        </button>
      </div>
      <div class="chatFooter">
        {chat.$s.logo}
        <div></div>
      </div>
    </div>
  )
}
